<template>
  <div class="expert-tool-safety-precautions">
    <v-alert v-if="safetyPrecautions.length == 0" type="info">
      {{ $ucfirst($t('expertTool.emptySafetyPrecautions')) }}
    </v-alert>
    <v-expansion-panels class="mb-6 mt-8">
      <v-expansion-panel
        v-for="(group, i) in safetyPrecautions"
        :key="`${group.name}-${i}`"
      >
        <v-expansion-panel-header>
          {{ group.name }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div
            v-for="(precaution, j) in group.items"
            :key="`${i}-${j}`"
            class="expert-tool-safety-precautions__list-item"
            v-html="precaution"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <unsaved-changes-warning ref="unsavedChangesWarning"></unsaved-changes-warning>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UnsavedChangesWarning from "../../components/Parts/UnsavedChangesWarning.vue";

/**
 * Component ExpertToolSafetyPrecautions.vue
 *
 * @module ExpertToolSafetyPrecautions
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.9] app/src/APP_DASHBOARD/templates/views/ExpertTool/ExpertToolSafetyPrecautions.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'ExpertToolSafetyPrecautions',
  components: {
    UnsavedChangesWarning
  },
  computed: {
    ...mapGetters({
      safetyPrecautions: 'expertTool/safetyPrecautions',
      unsavedChanges: 'patientSummary/unsavedChanges'
    }),
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'PatientExpertToolSportsGoal'
      || to.name === 'PatientExpertToolHistory') {
        next();
        return;
    }
    if (this.unsavedChanges()) {
      this.$refs.unsavedChangesWarning.prepareToExit(to.name)
      return false;
    }
    next();
  }
};
</script>

<style lang="scss">
.expert-tool-safety-precautions {
  .v-expansion-panel {
    border-bottom-width: 0 !important;
  }

  .v-expansion-panel::before {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  }

  .v-expansion-panel-header {
    font-size: 1rem !important;
    font-weight: 600;
    padding: 24px;
  }

  .expert-tool-safety-precautions__list-item {
    margin-bottom: 16px;
  }
}
</style>
